export default "__VITE_ASSET__OestAvA2SyLT4CG6L76dAw__";